import React, { lazy, Suspense, useEffect } from 'react'
import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { trackPageView } from './config/analytics'
import Loader from './components/Loader'
import ChatWidget from './components/general/ChatWidget'


const Home = lazy(() => import("./pages/Home"))
const NewsnUpdate = lazy(() => import("./pages/NewsnUpdate"))
const Autobot = lazy(() => import("./pages/Autobot"))
const CbtLink = lazy(() => import("./pages/CbtLink"))
const Services = lazy(() => import("./pages/Services"))
const CaseStudies = lazy(() => import("./pages/CaseStudies"))
const EdTech = lazy(() => import("./pages/EdTech"))
const GovTech = lazy(() => import("./pages/GovTech"))
const CyberSecurity = lazy(() => import("./pages/CyberSecurity"))
const Security = lazy(() => import("./pages/Security"))
const WhoWeAre = lazy(() => import("./pages/WhoWeAre"))
const SuppportPage = lazy(() => import("./pages/SuppportPage"))
const AppDev = lazy(() => import("./pages/AppDev"))
const Support = lazy(() => import("./pages/Support"))
const NetServices = lazy(() => import("./pages/NetServices"))
const TelecomServices = lazy(() => import("./pages/TelecomServices"))
const NewsDetailsPage = lazy(() => import("./pages/NewsDetailsPage"));
const PageNotFound = lazy(() => import("./pages/PageNotFound"))
const JupebMaintenance = lazy(() => import("./pages/JupebMaintenance"))
const JambMaintenance = lazy(() => import("./pages/JambMaintenance"))
const NecoMaintenance = lazy(() => import("./pages/NecoMaintenance"))



const App = () => {

  useEffect(() => {
    trackPageView();
  }, []);
  
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/edTech" element={<EdTech />} />
          <Route path="/govTech" element={<GovTech />} />
          <Route path="/cyber-security" element={<CyberSecurity />} />
          <Route path="/security" element={<Security />} />
          <Route path="/appDev" element={<AppDev />} />
          <Route path="/support" element={<Support />} />
          <Route path="/netServices" element={<NetServices />} />
          <Route path="/telecomServices" element={<TelecomServices />} />
          <Route path="/whoWeAre" element={<WhoWeAre />} />
          <Route path="/news-update" element={<NewsnUpdate />} />
          <Route
            path="/newsDetailsPage/:blogTitle"
            element={<NewsDetailsPage />}
          />
          <Route path="/suppportPage" element={<SuppportPage />} />
          <Route path="/document/auto-bot" element={<Autobot />} />
          <Route path="/cbt-link" element={<CbtLink />} />
          <Route path="/jupeb-maintenance" element={<JupebMaintenance />} />
          <Route path="/jamb-maintenance" element={<JambMaintenance />} />
          <Route path="/neco-maintenance" element={<NecoMaintenance />} />
          <Route path="*" Component={PageNotFound} />
        </Routes>

        <ChatWidget />
      </Suspense>
    </BrowserRouter>
  );
}

export default App

